// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets//fonts//Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets//fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets//fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fontWeight with 400 */
@font-face {
  font-family: "Inter-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

/* fontWeight with 500 */
@font-face {
  font-family: "Inter-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

/* fontWeight with 600 */
@font-face {
  font-family: "Inter-SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

/* fontWeight with 800 */
@font-face {
  font-family: "Inter-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

/* body {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
} */

.App {
  height: 100vh !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,4BAA4B;EAC5B,+DAAiE;AACnE;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,+DAA+D;AACjE;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,+DAAiE;AACnE;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,+DAA6D;AAC/D;;AAEA;;;;GAIG;;AAEH;EACE,wBAAwB;AAC1B","sourcesContent":["/* fontWeight with 400 */\n@font-face {\n  font-family: \"Inter-Regular\";\n  src: url(\"./assets//fonts//Inter-Regular.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 500 */\n@font-face {\n  font-family: \"Inter-Medium\";\n  src: url(\"./assets//fonts/Inter-Medium.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 600 */\n@font-face {\n  font-family: \"Inter-SemiBold\";\n  src: url(\"./assets//fonts/Inter-SemiBold.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 800 */\n@font-face {\n  font-family: \"Inter-Bold\";\n  src: url(\"./assets/fonts/Inter-Black.ttf\") format(\"truetype\");\n}\n\n/* body {\n  box-sizing: border-box;\n  margin: 0px;\n  padding: 0px;\n} */\n\n.App {\n  height: 100vh !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
